import React, { Component } from 'react';

class ZeroProductSubmitModal extends Component {
  render() {
    const { onSubmitProductCaseYes, onSubmitProductCaseNo, caseDetail } = this.props;
    return (
      <div
        className="modal fade theme-modal qty-modal"
        id="zeroProductSubmitModal"
        tabIndex="-1"
        aria-labelledby="zeroProductSubmitModal"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered modal-sm">
          <div className="modal-content">
            <div className="modal-body">
              <h5 className="modal-title" id="zeroProductSubmitModal">OPtimize</h5>
              <p>{`You are submitting ${caseDetail.case_products !== undefined ? caseDetail.case_products.length : 0}
               ${caseDetail.case_products !== undefined && caseDetail.case_products.length > 1 ? 'products' : 'product'}. Continue?`}
              </p>
            </div>
            <div className="modal-footer">
              <div className="row gx-2 button-wrap">
                <div className="col-6">
                  <button
                    type="button" className="btn btn-link btn-left w-100"
                    data-bs-dismiss="modal"
                    onClick={() => onSubmitProductCaseNo()}
                  >No
                  </button>
                </div>
                <div className="col-6">
                  <button
                    type="button" className="btn btn-link w-100"
                    onClick={() => onSubmitProductCaseYes()}
                  >Yes
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default ZeroProductSubmitModal;
